import { xBoxPlot } from "./xBoxPlot.js";
/**
 * Calculating the box plot of the array with outliers
 * Values are outliers if they are below Q1 - 1.5 * IQR or above Q3 + 1.5 * IQR
 * @param array - data
 * @returns - q1, median, q3, min, max, outliers
 */
export function xBoxPlotWithOutliers(array) {
    const boxPlot = xBoxPlot(array);
    const iqr = boxPlot.q3 - boxPlot.q1;
    const lowerWhisker = boxPlot.q1 - 1.5 * iqr;
    const upperWhisker = boxPlot.q3 + 1.5 * iqr;
    const outliers = [];
    let minWhisker = boxPlot.median;
    let maxWhisker = boxPlot.median;
    for (const value of array) {
        if (value < lowerWhisker || value > upperWhisker) {
            outliers.push(value);
        }
        else {
            if (value < minWhisker)
                minWhisker = value;
            if (value > maxWhisker)
                maxWhisker = value;
        }
    }
    const info = {
        ...boxPlot,
        lowerWhisker,
        upperWhisker,
        minWhisker,
        maxWhisker,
        iqr,
        outliers,
    };
    return info;
}
//# sourceMappingURL=xBoxPlotWithOutliers.js.map